<div class="container">
  <div class="mt-5 text-center text-muted">
    <i class="cc-icon cc-icon-spinner"></i>
    <h3 class="h3" i18n>Redirecting...</h3>
  </div>
</div>
